import React from "react"
import styles from "./styles.scss"
import SmallBox from "../SmallBox"
import {
  getCategoryByCounty,
  selectCategoriesAsArray,
} from "data/categories"
import { connect } from "react-redux"
import cx from 'classnames'

class CategoriesContainer extends React.Component {
  state = {
    selectedCounty: {},
  }
  componentDidMount() {
    const county = JSON.parse(localStorage.getItem("County"))
    this.setState({selectedCounty: county})
    county && this.props.getCategoryByCounty(county.id)
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.county.id !== this.props.county.id) {
      this.props.getCategoryByCounty(nextProps.county.id)
      this.setState({selectedCounty: nextProps.county})
    }
  }
  render() {
    const { categories } = this.props, {selectedCounty} = this.state
    return (
      <div className={styles.container}>
        {selectedCounty && <h2 className={styles.categoriesHeader}>{categories.length > 0 ? "Tjänster i "+selectedCounty.name : "Hittade inga tjänster i vald kommun"}</h2>}
        <div className={cx(styles.categoriesWrapper, categories.length > 0 ? styles.expanded : styles.collapsed )}>
          {categories &&
            categories.map(category => (
              <SmallBox
                key={category.id}
                category={category}
                text={category.name}
              />
            ))}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  categories: selectCategoriesAsArray(state, ownProps),
})
export default connect(
  mapStateToProps,
  {
    getCategoryByCounty,
  }
)(CategoriesContainer)



// WEBPACK FOOTER //
// src/pages/LandingPage/components/CategoriesContainer/index.jsx